var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9998,
    cy: 15.9998,
    r: 15.7498,
    fill: "#FAFCFF",
    stroke: "#E5ECF6",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5975_27151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9,
    width: 24,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9605 29.0585H28.022V32H5.3457V29.0585H7.40718V10.0307C7.40718 9.75737 7.51578 9.4952 7.70908 9.3019C7.90238 9.1086 8.16456 9 8.43793 9L18.7453 11.64C19.0187 11.64 19.2809 11.7486 19.4742 11.9419C19.6675 12.1352 19.7761 12.3974 19.7761 12.6707V29.0585H21.8376V16.9444H24.9298C25.2031 16.9444 25.4653 17.053 25.6586 17.2463C25.8519 17.4396 25.9605 17.7018 25.9605 17.9752V29.0585ZM11.5301 21.0674V19.0059H15.6531V21.0674H11.5301ZM11.5301 16.9444V14.883H15.6531V16.9444H11.5301ZM11.5301 25.1392V23.08H15.6531V25.1392H11.5301Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5975_27151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#B2C5E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.7964faa5f35586f3943a106b2f82c3ec.svg";
export { ForwardRef as ReactComponent };